(ns common.schema.entities.workspace.kyc.questions.contract
  (:require
   [common.email :as common-email]
   [common.country :as country]
   [common.schema.entities.workspace.kyc.kyc-options :as kyc-options]))

(def all-questions
  {:contract-kyc/business-name
   {:data/type    :data.type/text-simple
    :translations {:en "Name of the company"
                   :fi "Yrityksen nimi"}}

   :contract-kyc/business-id
   {:data/type    :data.type/text-simple
    :translations {:en "Business ID"
                   :fi "Y-tunnus"}}

   :contract-kyc/mailing-address
   {:data/type    :data.type/text-multiline
    :translations {:en "Mailing address"
                   :fi "Postisoite"}}

   :contract-kyc/registered-address
   {:data/type    :data.type/text-simple
    :translations {:en "Registered address"
                   :fi "Osoite"}}

   :contract-kyc/zip-code
   {:data/type    :data.type/text-simple
    :translations {:en "Zip code"
                   :fi "Postinumero"}}

   :contract-kyc/city
   {:data/type    :data.type/text-simple
    :translations {:en "City"
                   :fi "Kaupunki"}}

   :contract-kyc/domicile
   {:data/type    :data.type/keyword
    :options      country/options
    :translations {:en "Domicile"
                   :fi "Kotipaikka"}}

   :contract-kyc/listed-in-stock-exchange?
   {:data/type    :data.type/keyword
    :options      kyc-options/yes-no-options
    :translations {:en "Is the company listed on stock exchange stated in details"
                   :fi "Onko yritys listattu pörssiin?"}}

   :contract-kyc/ubo-edn
   {:data/type         :data.type/text-edn
    :edn-data/type     :edn-data.type/ubo-list
    :translations      {:en "Ultimate Beneficial Owners (UBOs)"
                        :fi "Tosiasialliset edunsaajat"}
    :data/template     {}
    :optional-field?   false
    :conditional-field (fn [answers]
                         (not= (:contract-kyc/listed-in-stock-exchange? answers) :yes))}

   :contract-kyc/confirmation-place
   {:data/type    :data.type/text-simple
    :translations {:en "Place"
                   :fi "Paikka"}}

   :contract-kyc/confirmation-date
   {:data/type    :data.type/date
    :translations {:en "Date"
                   :fi "Päivämäärä"}}

   :contract-kyc/confirmation-name
   {:data/type    :data.type/text-simple
    :translations {:en "Name"
                   :fi "Nimi"}}

   :contract-kyc/number-of-signers
   {:data/type    :data.type/keyword
    :options      [{:key          :one
                    :translations {:en "One signer"
                                   :fi "Yksi allekirjoittaja"}
                    :ord          1.0}
                   {:key          :two
                    :translations {:en "Two signers"
                                   :fi "Kaksi allekirjoittajaa"}
                    :ord          2.0}]
    :translations {:en "Number of signers"
                   :fi "Allekirjoittajien määrä"}}

   :contract-kyc/signer-name-1
   {:data/type    :data.type/text-simple
    :translations {:en "Signer name 1"
                   :fi "Allekirjoittajan nimi 1"}}

   :contract-kyc/signer-email-1
   {:data/type      :data.type/email
    :mandatory-field?  (fn [_answers kyc-process]
                         (= :kyc-process.status/wip (:kyc-process/status kyc-process)))
    :validation-fn  (fn [{:keys [answers]}]
                      (when-not (common-email/optional-valid-email? (:contract-kyc/signer-email-1 answers))
                        :invalid-email))
    :translations {:en "Signer email 1"
                   :fi "Allekirjoittajan sähköposti 1"}}

   :contract-kyc/signer-name-2
   {:data/type         :data.type/text-simple
    :conditional-field (fn [answers]
                         (= (:contract-kyc/number-of-signers answers) :two))
    :translations      {:en "Signer name 2"
                        :fi "Allekirjoittajan nimi 2"}}

   :contract-kyc/signer-email-2
   {:data/type         :data.type/email
    :conditional-field (fn [answers]
                         (= (:contract-kyc/number-of-signers answers) :two))
    :mandatory-field?  (fn [_answers kyc-process]
                         (= :kyc-process.status/wip (:kyc-process/status kyc-process)))
    :validation-fn     (fn [{:keys [answers]}]
                         (when-not (common-email/optional-valid-email? (:contract-kyc/signer-email-2 answers))
                           :invalid-email))
    :translations      {:en "Signer email 2"
                        :fi "Allekirjoittajan sähköposti 2"}}

   :contract-kyc/signature-info-1
   {:data/type    :data.type/text-multiline
    :translations {:en ""
                   :fi ""}}

   :contract-kyc/signature-info-2
   {:data/type    :data.type/text-multiline
    :translations {:en ""
                   :fi ""}}

   :contract-kyc/signature-place
   {:data/type    :data.type/text-simple
    :translations {:en "Place"
                   :fi "Paikka"}}

   :contract-kyc/signature-date
   {:data/type    :data.type/date
    :translations {:en "Date"
                   :fi "Päivämäärä"}}

   :contract-kyc/signature-name
   {:data/type    :data.type/text-simple
    :translations {:en "Name"
                   :fi "Nimi"}}

   :contract-kyc/signature-signature
   {:data/type    :data.type/text-simple
    :translations {:en "Signature"
                   :fi "Allekirjoitus"}}

   :contract-kyc/signature-place-2
   {:data/type    :data.type/text-simple
    :translations {:en "Place"
                   :fi "Paikka"}}

   :contract-kyc/signature-date-2
   {:data/type    :data.type/date
    :translations {:en "Date"
                   :fi "Päivämäärä"}}

   :contract-kyc/signature-name-2
   {:data/type    :data.type/text-simple
    :translations {:en "Name"
                   :fi "Nimi"}}

   :contract-kyc/signature-signature-2
   {:data/type    :data.type/text-simple
    :translations {:en "Signature"
                   :fi "Allekirjoitus"}}})
